<script>
    // HLC Area Chart Renderer (High-Low-Close Area)
    import HLCAreaPrimitive from './primitives/hlc_area.js'
    import Price from './primitives/price.js'
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'HLCArea',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'TradingCandle', 
                    version: '1.0.0',
                    desc: 'HLC Area Chart',
                    preset: {
                        name: 'HLCArea',
                        side: 'onchart',
                        settings: {
                            lineColor: '#2962ff',
                            fillColor: '#2962ff20',
                            lineWidth: 2,
                            priceLine: false
                        }
                    }
                }
            },
            init() {
                this.price = new Price(this)
            },
            draw(ctx) {
                let layout = this.$props.layout
                let candles = this.$props.sub === this.$props.data ?
                    layout.candles : layout_cnv(this).candles
                
                if (candles.length > 0) {
                    new HLCAreaPrimitive(this, ctx, layout, candles)
                }

                if (this.price_line) this.price.draw(ctx)
            },
            use_for() { return ['HLCArea'] },

            // When added as offchart overlay
            y_range() {
                if (!this.$props.sub.length) return [0, 0]
                return [
                    Math.max(...this.$props.sub.map(x => x[2])),
                    Math.min(...this.$props.sub.map(x => x[3]))
                ]
            }
        },

        computed: {
            sett() {
                return this.$props.settings
            },
            price_line() {
                return 'priceLine' in this.sett ?
                    this.sett.priceLine : false
            },
            lineColor() {
                return this.sett.lineColor || "#2962ff"
            },
            fillColor() {
                return this.sett.fillColor || "#2962ff20"
            },
            lineWidth() {
                return this.sett.lineWidth || 2
            }
        }
    }
</script>
